import { Fragment } from 'react';

import { AccordionDetails, Grid, Typography } from '@frontierag/frontier-ui-library';
import useDataFieldHelpers from 'hooks/useDataFieldHelpers';

import type { IAccordionDynamicCells } from '../types';

export default function AccordionDynamicCells({
  data,
  dynamicCells,
  sx = {},
}: IAccordionDynamicCells) {
  const { renderValue, renderLabel } = useDataFieldHelpers(data);

  return (
    <AccordionDetails data-testid="accordion-row-content" sx={sx}>
      <Grid direction="row" xs={12} container item spacing={1} alignItems="baseline">
        {dynamicCells.map((field, index) => (
          <Fragment key={`dynamic-row-${index}`}>
            <Grid item xs={5}>
              <Typography variant="label2" data-testid={`${field.name}-label`}>
                {renderLabel(field)}:
              </Typography>
            </Grid>
            <Grid item xs={7} sx={{ fontSize: '14px' }} data-testid={`${field.name}-value`}>
              {renderValue(field)}
            </Grid>
          </Fragment>
        ))}
      </Grid>
    </AccordionDetails>
  );
}
